import Service from '../service/Service';
const service = new Service();

export function getSessionDate(date1, type){
    // debugger;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var date = date1.replace(/-/g,"/");
    let monthStr = date.split("/")[1];
    let dd;
    if(isNaN(monthStr)){
        for(let k =0; k<monthNames.length; k++) {
            if (monthNames[k].includes(monthStr)){
                dd = date.split("/")[0] + "-" + (k + 1) + "-" + date.split("/")[2]
                break;
            }
        }
    } else {
        dd = date.split("/")[0] + "-" + Number(monthStr) + "-" + date.split("/")[2];
    }
    let d = new Date(dd.replace(/-/g,"/"));
    let mth = d.getMonth();
    let dt = d.getDate();
    let yr = d.getFullYear();
    let hrs = d.getHours();
    let min = d.getMinutes();
    let ampm;
    if(hrs >= 12 && hrs != 24){
        ampm = "PM";
        if(hrs > 12)
            hrs = hrs - 12;
    }
    else{
        ampm = "AM";
        if(hrs == 24)
            hrs = hrs - 12;
    }
    if (min.toString().length < 2)
        min = "0" + min;

    if(type == "datetime"){
        let newdate = monthNames[mth] + " " + dt + " - " + hrs + ":" + min + " " + ampm;
        return newdate;
    }else if(type == "onlydate"){
        return dt;
    }else if(type == "onlymonth"){
        return monthNames[mth];
    }else if(type == "onlytime"){
        return (hrs + ":" + min + " " + ampm);
    }else if(type == "fulldate"){
        let newdate = dt + " " + monthNames[mth] + " " + yr;
        return newdate;
    }
} 

export function postComment(videoid, eleRef){
    if (global.ftk != '') {
        // debugger;
        let userComment = document.querySelector(".comment-here").value;
        if(userComment == ''){
            showMsg("Please enter comment");
        }
        else {
            service.showLoader();
            var postData = {
                "videoid": videoid,
                "userComment": userComment
            }
            // console.log(postData);
            var url = global.api_ci_url + "FacebookLiveFeed/postcomment";
            service.postServiceCall(url, postData).then((json) => {
                // debugger;
                if (json['msg'] == "1" && json['result']) {
                    document.querySelector(".comment-here").value = "";
                    eleRef.setState({chars_left : 255});
                    setTimeout(function () {
                        eleRef.getcommentData(videoid);
                        if(eleRef.state.commentCount > 3){
                            document.querySelector(".load-cmts") && (document.querySelector(".load-cmts").style.display = "block");
                        } else {
                            document.querySelector(".load-cmts") && (document.querySelector(".load-cmts").style.display = "none");
                        }
                    }, 200);
                    // service.showAlert("success");
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }
    } else {
        // service.showAlert("Please Login");
        // window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        // return false;
         if (eleRef.state.isApp) {
            loginCallBack(global.currentURL);
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
}

function loginCallBack1(redirectUrl) {
    if(redirectUrl){
        var deepjson = {
            "appurl": [{
                "pagetype": "login",
                "url": "https:\/\/www.firstcry.com\/m\/login?from=app",
                "redirecturl": redirectUrl
            }]
        }
    }else{
        var deepjson = {
            "appurl": [{
                "pagetype": "login",
                "url": "https:\/\/www.firstcry.com\/m\/login?from=app"
            }]
        }
    }  
    service.jsontracker(JSON.stringify(deepjson));
}

 function onAppNetwrokChange(){
    let isConected;
    if(navigator.onLine) {
        isConected=true;
    }else{
        isConected=false;
    }
    if(isConected){
        var deepjson = {
            "appurl": [{
                "isConected": isConected
            }]
        }
    }else{
        var deepjson = {
            "appurl": [{
                "isConected": isConected
            }]
        }
    }  
    service.jsontracker(JSON.stringify(deepjson));
}



export function getRedirectUrl(videoTitle, videoId, isApp, e) {
   
    var newvideoTitle=replaceSymbols(videoTitle);
    var redirectUrl="/live-sessions/"+newvideoTitle+"/"+videoId;
     console.log("newvideoTitle"+redirectUrl); 
   
    if (redirectUrl.indexOf("https://parenting.firstcry.com") == 0) {
      redirectUrl = redirectUrl.replace("https://parenting.firstcry.com", "");
    } else if (redirectUrl.indexOf("http://parenting.firstcry.com") == 0) {
      redirectUrl = redirectUrl.replace("http://parenting.firstcry.com", "");
    }
    if (navigator.onLine) {
        var currentUrl = global.currentURL;
        if (currentUrl.includes('from=app')) {
            if (redirectUrl.includes('?')) {
                window.location.href = redirectUrl + "/&from=app";
            } else {
                window.location.href = redirectUrl + "/?from=app";
            }
        } else {
            window.location.href = redirectUrl;
        }
    } else {
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
  }

export function replaceSymbols(val) {
    console.log("replaceSymbols"+val);
    if (val) {
      var mainurl = val.trim().toLowerCase();
      mainurl = mainurl.replace(/[\W_]+/g, "-");
      mainurl = mainurl.replace("---", "-");
      mainurl = mainurl.replace("--", "-");
      if (mainurl.charAt(0) == '-') {
        mainurl = mainurl.substr(1);
      }
      return mainurl;
    } else {
      return val;
    }
  }

export function likeVideo(count, videoid){
    if (global.ftk != '') {
        if(!document.querySelector(".likes-section .likeicon").classList.contains("liked")){
            service.showLoader();
            // debugger;
            var postData = {
                "videoid": videoid
            }
            var url = global.api_ci_url + "FacebookLiveFeed/likeVideo";
            service.postServiceCall(url, postData).then((json) => {
                if (json['msg'] == "1" && json['result']) {
                    // debugger
                    document.querySelector(".likes-section .likeicon").classList.add("liked");
                    document.querySelector(".likes-section .likecount").innerHTML = (parseInt(count) + 1) + " Likes";
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function shareOn(id,isApp,bannerUrl,videoTitle,description) {
        if(isApp){
            
            if(bannerUrl){
                var thmbnailurl=bannerUrl;
            }else{
                var thmbnailurl="";
            }

            if(videoTitle){
                var title=videoTitle;
            }else{
                var title="";
            }

            if(description){
                var desc=description;
            }else{
                var desc="";
            }


            var sessionUrl = window.location.href;

            var deepjson = {
                "appurl": [{
                    "pagetype": "share",
                    "shareText": "Here is an interesting Firstcry Parenting",
                    "thumbnailUrl": thmbnailurl,
                    "shareUrl": sessionUrl,
                    "desc": desc,
                    "title": title
                }]
            };
            service.jsontracker(JSON.stringify(deepjson));
        }else{

            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'block';
            if (window.innerWidth < 767) {
                if (document.getElementsByClassName('share-overlay')[0]) {
                    document.getElementsByClassName('share-overlay')[0].style.display = 'block';
                }
            }
        }
}

export function shareArticle(shareoption, articleurl) {
    var shareurl;
    if (!articleurl.includes('http')) {
        articleurl = 'https:' + articleurl;
    }
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    if (document.getElementsByClassName('share-overlay')[0]) {
        document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    }
    if (shareoption == "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption == "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption == "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption == "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}


export function loginCallBack() {
        var deepjson = {
            "appurl": [{
                "pagetype": "communityloginregister",
                "communityWebViewUrl": "https://www.firstcry.com/m/login?from=app",
                "afterloginreloadpageurl": window.location.href
            }]
        }
        service.jsontracker(JSON.stringify(deepjson));
    }



export function registerNow(videoTitle, videoId, isApp, e){
    var _this = e.target.parentElement.className;
    // debugger;
    if(!e.target.classList.contains("regbtn-disable")){
        if (navigator.onLine) {
            if (global.ftk != '') {
                service.showLoader();
                // debugger;
                var postData = {
                    "videoid": videoId
                }
                var url = global.api_ci_url + "FacebookLiveFeed/registerUser";
                service.postServiceCall(url, postData).then((json) => {
                    // debugger;
                    if (json['msg'] == "1" && json['result']) {

                        if(isApp){
                            showMsg("Thank you for Registering");
                            setTimeout(function () {
                                window.location.href=window.location.href
                            },1000);
                        }else{
                            document.querySelector("."+_this).querySelector(".register-btn").classList.add("regbtn-disable");
                            document.querySelector("."+_this).querySelector(".register-btn").innerHTML = "You Are Registered";
                            showMsg("Thank you for Registering");
                        }

                    }
                    service.hideLoader();
                }).catch((error) => {
                    console.error(error);
                    service.hideLoader();
                });
            } else {
                    if (isApp) {
                        loginCallBack();
                } else {
                    service.showAlert("Please Login");
                    window.location.href = global.loginUrl + '?URL=' + global.currentURL;
                    return false;
                }
            }
        } else {
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }
}
export function getMoreComments(videoId, eleRef){
    if (navigator.onLine) {
        // if (global.ftk != '') {
            service.showLoader();
            // debugger;
            var postData = {
                "pageno": "1",
                "pagesize": eleRef.state.commentCount,
                "videoId": videoId
            }
            var url = global.api_ci_url + "FacebookLiveFeed/getMoreComments";
            service.postServiceCall(url, postData).then((json) => {
                // debugger;
                // console.log(eleRef.state.commentList);
                // console.log(json['result']);
                eleRef.setState({ commentList: json['result']});
                document.querySelector(".load-cmts").style.display = "none";
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        // } else {
        //     service.showAlert("Please Login");
        //     window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        //     return false;
        // }
    } else {
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}
export function domClick(event) {
    if (!event.target.classList.contains('share-section') && !event.target.matches('.fb-icon img') && !event.target.classList.contains('whtap-icon') && !event.target.classList.contains('share-in')) {
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'none';
        }
    }
}
function showMsg(msg){
    document.getElementsByClassName('fblivemsg')[0] && (document.getElementsByClassName('fblivemsg')[0].innerHTML = msg);
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    document.getElementsByClassName('fblivemsg-overlay')[0] && (document.getElementsByClassName('fblivemsg-overlay')[0].style.display = "block");
    setTimeout(function () {
      document.getElementsByClassName('fblivemsg-overlay')[0] && (document.getElementsByClassName('fblivemsg-overlay')[0].style.display = "none");
      document.getElementsByTagName('body')[0].style.overflow = 'visible';
      document.getElementsByClassName('fblivemsg')[0] && (document.getElementsByClassName('fblivemsg')[0].innerHTML = "");
    }, 2000);
}

// export function getMoreSessions(eleref){
//     eleref.getsessionLinedupData(true);
// }
